import { AfterViewInit, DestroyRef, Directive, ElementRef, Input, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, tap } from 'rxjs/operators';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { SimpleTableGroupState } from './group-state.enum';

@Directive({
  selector: '[tableGroup]',
  standalone: false
})
export class TableGroupDirective implements AfterViewInit {
  private elementRef = inject<ElementRef<Element>>(ElementRef);
  private destroyRef = inject(DestroyRef);

  // eslint-disable-next-line rxjs/finnish
  @Input() tableGroup: Observable<SimpleTableGroupState[]>;

  ngAfterViewInit(): void {
    this.tableGroup
      .pipe(
        filter(() => !!this.elementRef),
        tap(() => this.resetClasses())
      )
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(inactiveColumns => {
        inactiveColumns.forEach((state, index) => {
          if (state !== SimpleTableGroupState.Visible) {
            this.elementRef.nativeElement.children.item(index).classList.add(state);
          }
        });
      });
  }

  private resetClasses(): void {
    for (let i = 0; i < this.elementRef.nativeElement.children.length; i++) {
      this.elementRef.nativeElement.children
        .item(i)
        .classList.remove(SimpleTableGroupState.Inactive, SimpleTableGroupState.Hidden);
    }
  }
}
